import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import api, { formatApiErrorDetail } from "@/lib/api";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.next.length < 8) return setError("La nueva contraseña debe tener al menos 8 caracteres.");
    if (form.next !== form.confirm) return setError("Las contraseñas nuevas no coinciden.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Contraseña cambiada");
      setForm({ current: "", next: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); setError(""); }}>
      <DialogTrigger asChild>
        <Button data-testid="change-password-open" variant="ghost" size="sm" className="w-full mt-2">
          <KeyRound size={14} className="mr-2" /> Cambiar contraseña
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Cambiar contraseña</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="cp-current">Contraseña actual</Label>
            <Input id="cp-current" type="password" autoComplete="current-password" required data-testid="change-password-current" value={form.current} onChange={set("current")} />
          </div>
          <div>
            <Label htmlFor="cp-new">Nueva contraseña</Label>
            <Input id="cp-new" type="password" autoComplete="new-password" required data-testid="change-password-new" value={form.next} onChange={set("next")} />
          </div>
          <div>
            <Label htmlFor="cp-confirm">Repite la nueva contraseña</Label>
            <Input id="cp-confirm" type="password" autoComplete="new-password" required data-testid="change-password-confirm" value={form.confirm} onChange={set("confirm")} />
          </div>
          {error && <div data-testid="change-password-error" className="text-sm text-red-600">{error}</div>}
          <Button type="submit" data-testid="change-password-submit" className="w-full bg-[#026FCB] hover:bg-[#0358a5]" disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
